import { P0, S, abs, arc, fillAt, rotPts } from '../../geometry';

export const spring = {
  name: 'Spring',
  colors: ['#2F9E5B', '#E3A008'],
  draw(m, t) {
    let H = 34 + 2 * S(t * 1.8),
      tilt = 3 * S(t * 1.1),
      pose = P0();
    if (m === 'happy') {
      H = 36 + 12 * abs(S(t * 6));
      tilt = 8 * S(t * 6);
    }
    // Thinking: keeps bobbing on its coil, head tilting.
    if (m === 'thinking') {
      H = 33 + 7 * S(t * 2.6);
      tilt = 9 * S(t * 1.3);
    }
    if (m === 'talking') {
      H = 34 + 3 * S(t * 10);
      tilt = 3 * S(t * 5);
    }
    if (m === 'surprised') {
      H = 50 + S(t * 30);
      tilt = 0;
    }
    if (m === 'paused') {
      H = 17 + 0.6 * S(t * 0.9);
      tilt = -10;
    }
    const top = 86 - H;
    const coil = [];
    for (let k = 0; k <= 10; k++)
      coil.push([
        50 + 15 * (k % 2 ? 1 : -1) * (k === 0 || k === 10 ? 0.55 : 1),
        86 - (k * H) / 10,
      ]);
    const head = rotPts([...arc(50, top, 19, 180, 360, 9)], 50, top, tilt),
      cap = rotPts(
        [
          [31, top],
          [69, top],
        ],
        50,
        top,
        tilt
      );
    const eye = rotPts([[50, top - 8]], 50, top, tilt)[0];
    return {
      strokes: [
        { c: 'b', pts: coil },
        { c: 'a', pts: head },
        { c: 'a', pts: cap },
        {
          c: 'a',
          pts: [
            [30, 88],
            [70, 88],
          ],
        },
      ],
      eyes: { x: eye[0], y: eye[1] },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1),
};
